if($('.type-detail').length){

    const storedLanguageString = localStorage.getItem('selectedLanguage');
    if (storedLanguageString) {
        var storedLanguage = JSON.parse(localStorage.getItem('selectedLanguage'));
        if(langName === storedLanguage.name){

        }
        else{
            let codes = getShoptetDataLayer('product').codes[0].code;
            const langSelector = storedLanguage.code;
            $.ajax({
                url: "https://tools.shopcode.cz/rdo/get_translations.php",
                type: "GET",
                data: { codes: codes},
                dataType: "json",
                success: function (response) {
                    console.log("✅ Přijatá data:", response);
                    $.each(response, function (code, data) {
                            if (data.translations && typeof data.translations === 'object' && !Array.isArray(data.translations)) {
                                let translation = data.translations[langSelector];
                                if (translation && typeof translation === 'object') {
                                    $('.p-detail-inner-header h1').text(translation.name)
                                    $('.p-info-wrapper .p-short-description').html(translation.shortdescription);
                                } else {
                                }
                            } else {
                            }
                        
                    });
                },
                error: function (xhr, status, error) {
                    console.error("❌ Chyba při získávání překladů:", status, error);
                }
            });
        }
      
    } else {
        console.log("Žádná data v sessionStorage nejsou.");
    }



    if ($('.p-thumbnails-wrapper .p-thumbnails-inner').length) {
        $('.p-image-wrapper').addClass('haveThumbnails')
        $('.p-image-wrapper').append('<span class="arrowsImages arrow-prev"></span><span class="arrowsImages arrow-next"></span>');
        $('body').on('click', '.arrow-prev, .arrow-next', function () {
            var thumbnails = $('.p-thumbnails-inner').find('a.p-thumbnail, a.show360image');
            var highlightedThumbnail = $('.p-thumbnails-inner').find('a.highlighted');
            var isNext = $(this).hasClass('arrow-next');
            var totalThumbnails = thumbnails.length;
            var currentIndex = thumbnails.index(highlightedThumbnail);
            thumbnails.removeClass('highlighted');
            if (highlightedThumbnail.length === 0) {
                highlightedThumbnail = isNext ? thumbnails.first() : thumbnails.last();
            } else {
                currentIndex = isNext ? (currentIndex + 1) % totalThumbnails : (currentIndex - 1 + totalThumbnails) % totalThumbnails;
                highlightedThumbnail = thumbnails.eq(currentIndex);
            }
            highlightedThumbnail.addClass('highlighted');
            toggle360ImageVisibility(highlightedThumbnail);
            setTimeout(function () {
                updateMainImage(highlightedThumbnail);
                updateThumbnailCount(thumbnails);
            }, 10);
        });
        function updateMainImage(highlightedThumbnail) {
            var findHighlighted = highlightedThumbnail.attr('href');
            var findHighlightedAlt = highlightedThumbnail.find('img').attr('alt');
            $('.p-image a.p-main-image').attr('href', findHighlighted).find('img').attr({'src': findHighlighted, 'alt': findHighlightedAlt});
        }
        function updateThumbnailCount(thumbnails) {
            var highlightedIndex = thumbnails.index($('.p-thumbnails-inner a.highlighted')) + 1;
            var totalThumbnails = thumbnails.length;
            $('.thumbCount .from').html(highlightedIndex);
            $('.thumbCount .to').html(totalThumbnails);
        }
        function toggle360ImageVisibility(highlightedThumbnail) {
            var is360Image = highlightedThumbnail.hasClass('show360image');
            if (is360Image) {
                $('.image360').show();
                $('.p-image').hide();
            } else {
                $('.image360').hide();
                $('.p-image').show();
            }
        }
        updateThumbnailCount($('.p-thumbnails-inner').find('a.p-thumbnail, a.show360image'));
    }

    if ($('.p-detail-info a[data-testid="productCardBrandName"]').length) {
        var brandLink = $('.p-detail-info a[data-testid="productCardBrandName"]').attr('href')
        var brandName = $('.p-detail-info a[data-testid="productCardBrandName"]').text().trim().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\s+/g, "_");
        var imagePath = "/user/documents/upload/loga-znacek/" + brandName + ".png";
        $.get(imagePath)
            .done(function() {
                $('.p-info-wrapper').append('<div class="brandLogo"><span>'+vyrobce+'</span><a href="'+brandLink+'"><img src="' + imagePath + '" alt="logo ' + $('.p-detail-info a[data-testid="productCardBrandName"]').text().trim() + '"></a></div>');
                $('.p-detail-info>div a[data-testid="productCardBrandName"]').closest('div').hide()
            })
            .fail(function() {
                console.warn("Logo značky nenalezeno: " + imagePath);
            });
    }
    
    
    
        

    $('.stars-label').each(function() {
        var text = $(this).text();
        if (text.indexOf('(Již jste hlasovali)') !== -1) {
            $(this).text(text.replace('(Již jste hlasovali)', ''));
        }
    });

    $('.parameter-dependent').each(function(){
        if($(this).text().trim() === 'Zvolte variantu'){
            $(this).text('Dle varianty')
        }
    })
    $('.p-info-wrapper .delivery-time').closest('tr').hide()
    $('.p-info-wrapper').append('<div class="stockLine"></div>');
    $('.availability-value').prepend('<span class="title">'+$('.availability-value').attr('title')+':</span>')
    if($('.p-info-wrapper .delivery-time').length>0){
        $('.stockLine').append($('.p-info-wrapper .availability-value'))
        $('.stockLine').append($('.p-info-wrapper .delivery-time').closest('th').html())
    }
    else{
        $('.stockLine').append($('.p-info-wrapper .availability-value'))
        $('.stockLine').append($('.p-info-wrapper .shipping-options'))
       
    }
    $('.p-info-wrapper').append('<div class="customCart"></div>')
    $('.customCart').prepend($('.p-info-wrapper .p-final-price-wrapper'), $('.p-info-wrapper .add-to-cart'))
    $('.p-image-wrapper .p-image').append($('.p-detail-info .flags').clone())
    $('.social-buttons-wrapper').append($('.p-detail .p-detail-inner .p-detail-inner-header .p-code').clone())
    $('.p-info-wrapper').append($('.p-detail .p-detail-inner .p-detail-inner-header').clone(), $('.p-detail .p-detail-inner .product-top .col-xs-12:not(.col-lg-6) .p-detail-info').clone())
    if($('.extended-description .detail-parameters tr th:contains("#Tabulka velikostí:")').length>0){
        $('.extended-description .detail-parameters tr th:contains("#Tabulka velikostí:")').closest('tr').hide();
        $('.p-info-wrapper').append('<div class="sizeguid"><span class="chooseSizes" data-url="'+$('.extended-description .detail-parameters tr th:contains("#Tabulka velikostí:")').closest('tr').find('td').text()+'">Tabulka velikostí</span></div>');

    }
   
    if(!$('#simple-variants').length){
        if($('.variant-list, .surcharge-list').length>0){
            $('.variant-list select, .surcharge-list select').each(function(){
                if($(this).closest('.surcharge-list').find('th .show-tooltip').length){
                    var listTootip = $(this).closest('.surcharge-list').find('th .show-tooltip').attr('title')
                }
                else{
                    listTootip = ''
                }
                var optionLength = $(this).find('option').length
                var data_parameter_id = $(this).data('parameter-id')
                var html_var = '<div class="custom-variant" data-groupId="'+data_parameter_id+'"><div class="h3">'+$(this).attr('data-parameter-name')+'</div>'
                html_var += '<div class="custom-variant-wrap" data-param-id="'+data_parameter_id+'">'
                $(this).find('option').each(function(){
                    var data_value = $(this).attr('value')
                    if($(this).closest('td').find('select[name*="parameterValueId"]').length){
                        if ($.isNumeric($(this).val())) {
                            var textsplit = $(this).text().split('+')
                            html_var += '<div class="variant haveVariant" data-value="'+data_value+'" data-parameter-id="'+data_parameter_id+'" data-param-val="'+data_parameter_id+'-'+data_value+'">'
                            html_var += '<div class="text">'
                            if(typeof textsplit[1] === 'undefined'){
                                html_var += textsplit[0]
                            }
                            else{
                                html_var += textsplit[0]+' (+'+textsplit[1]+')'
                            }
                          
                            if(listTootip !== ''){
                                if(textsplit[1] !== '0 Kč'){
                                    html_var += '<span class="show-tooltip question-tooltip" title="'+listTootip+'">?</span>'
                                }
                            }
                            html_var += '</div>'
                            html_var += '</div>'
                        }
                    }
                    else{
                        if ($.isNumeric($(this).val())) {
                            var textsplit = $(this).text().split('+')
                            html_var += '<div class="variant haveSurcharge show-tooltip" title="'+$(this).text()+'" data-value="'+data_value+'" data-parameter-id="'+data_parameter_id+'" data-param-val="'+data_parameter_id+'-'+data_value+'">'
                            html_var += '<div class="image"><img src="/user/documents/upload/obrazky/detail/priplatky/'+data_value+'.svg?v='+new Date().getMinutes()+'" alt="'+$(this).text()+'"></div>'
                            html_var += '</div>'
                        }
                    }
                    
                })
                html_var += '</div>'
                html_var += '</div>'
                $(this).after(html_var)
                $(this).closest('.variant-list select, .surcharge-list select').hide()
               $(this).closest('.variant-list span, .surcharge-list span').hide()
              
            })
    
            var necessaryVariantData = shoptet.variantsSplit.necessaryVariantData;
            for (var parentKey in necessaryVariantData) {
                if (necessaryVariantData.hasOwnProperty(parentKey)) {
                    var variant = necessaryVariantData[parentKey];
                    $('.custom-variant-wrap .variant[data-param-val="'+parentKey+'"]').addClass('haveImage').attr('data-price-id', variant.id).attr('data-avail', variant.availabilityName.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/ /g, '-'))
                
                }
            }
            
        }
    }
    

    $(document).on('click', '.custom-variant-wrap .variant', function(){
        const variantData = $(this).data('value');
        const variantParameterId = $(this).data('parameter-id');
            $("select[data-parameter-id='"+variantParameterId+"'] option").filter(function (){
                return $(this).attr('value') == variantData;
            }).change().prop("selected", true);
            $(this).closest('.custom-variant-wrap[data-param-id="'+variantParameterId+'"]').find(".variant:not([data-value='"+variantData+"'])").removeClass("active");
            $(this).addClass("active"); 
        
    
        var selector = '.variant-list .hidden-split-parameter, .variant-list .split-parameter';
        var $splitParameters = $(selector);
        $splitParameters.trigger('change');
    
        $("select[data-parameter-id='"+variantParameterId+"']")[0].dispatchEvent(new Event('change'));
    
        $('.custom-variant-wrap .variant').each(function(){
            const variantData = $(this).data('value');
            const variantParameterId = $(this).data('parameter-id');
            const unavailable = $("select[data-parameter-id='"+variantParameterId+"'] option[value='" + variantData + "']").hasClass("unavailable-option");
            if (unavailable === true) {
                $(this).addClass("unavailable").removeClass("active");
            }
            else{
                $(this).removeClass("unavailable");
            } 
        });
    });

    $(document).on('click', '#jsUnavailableCombinationMessage a', function(){
        $('.custom-variant-wrap .variant').removeClass('unavailable')
    })
    $(document).ready(function(){
        $(".custom-variant-wrap").each(function() {
            var $variants = $(this).find("div.variant");
            if ($variants.length === 1) {
             $variants.addClass("active");
            }
          });
        var urlParams = new URLSearchParams(window.location.search);
        var parameterValueId = urlParams.get("parameterValueId");
        var $divToHighlight = $("div.variant[data-value='" + parameterValueId + "']");
        if ($divToHighlight.length > 0) {
            $divToHighlight.addClass("active");
        }
    })
    $(document).ready(function(){
        if($('.responsive-nav').length){
            if($('#p-detail-tabs').length){
                $('#p-detail-tabs').append($('.hidden-links').html())
            }
        }
    })
}

$(document).on('click', '.chooseSizes', function(){
    var urlToLoad = $(this).attr('data-url');
    $.get(urlToLoad, function(data) {
        var $html = $('<div>').html(data);
        var $about = $html.find('[itemprop="about"]');
        var content;
        if ($about.length) {
            content = $about.html();
           
        } else {
            var $newsItemDetailText = $html.find('.news-item-detail .text');
            var content = $newsItemDetailText.html();
           
            
        }
        $.colorbox({
            html: '<div class="sizesContent">'+content+'</div>',
            width: 1200,
            maxWidth: "95%",
            height: 800,
            maxHeight: "95%",
            className: "chooseSize",
            onComplete: function() {
                
            },
        });
    });
});